import React from 'react';
import {
  FaJava, FaPython, FaPhp, FaReact, FaAndroid, FaDocker, FaGitAlt,
  FaDatabase, FaJsSquare, FaServer, FaCode,
} from 'react-icons/fa';
import {
  SiSpring, SiFlutter, SiCplusplus, SiJenkins, SiApachemaven,
  SiFirebase, SiBootstrap, SiOpencv, SiStyledcomponents, SiFramer,
  SiTypescript, SiVite, SiTailwindcss, SiSupabase, SiLeaflet,
} from 'react-icons/si';
import { TbBrain, TbApi, TbRefresh, TbTestPipe, TbBoxMultiple } from 'react-icons/tb';
import { FiBox, FiSmartphone } from 'react-icons/fi';

// Map is intentionally lenient: any value that is undefined (e.g. an icon
// that doesn't exist in this version of react-icons) safely falls back.
const map = {
  'Java': FaJava,
  'JavaScript': FaJsSquare,
  'PHP': FaPhp,
  'Python': FaPython,
  'SQL': FaDatabase,
  'C++': SiCplusplus,
  'Spring Boot': SiSpring,
  'ReactJS': FaReact,
  'React': FaReact,
  'Flutter': SiFlutter,
  'GWT': FiBox,
  'Docker': FaDocker,
  'Git': FaGitAlt,
  'Jenkins': SiJenkins,
  'CircleCI': TbRefresh,
  'Maven': SiApachemaven,
  'Jira': TbBoxMultiple,
  'JBOSS': FaServer,
  'Agile / Scrum': TbRefresh,
  'Agile': TbRefresh,
  'REST': TbApi,
  'REST APIs': TbApi,
  'CI/CD': TbRefresh,
  'Testing': TbTestPipe,
  'Android': FaAndroid,
  'OpenCV': SiOpencv,
  'AI / ML': TbBrain,
  'Firebase': SiFirebase,
  'Bootstrap': SiBootstrap,
  'styled-components': SiStyledcomponents,
  'Framer Motion': SiFramer,
  'TypeScript': SiTypescript,
  'Vite': SiVite,
  'Tailwind CSS': SiTailwindcss,
  'Tailwind': SiTailwindcss,
  'Supabase': SiSupabase,
  'Leaflet': SiLeaflet,
  'PWA': FiSmartphone,
};

export const getTechIcon = (name) => {
  const Icon = map[name] || FaCode;
  return <Icon />;
};

export default getTechIcon;
